import { Reducer } from 'redux'
import { ActionTypes } from './constants'
import { ModalsState } from './types'
import { openModal, closeModal, setModalData } from './actions'

export type Action = ReturnType<
  typeof openModal | typeof closeModal | typeof setModalData
>

export const initialState: ModalsState = {
  visible: false,
  modalType: '',
  data: null,
  syntheticRouteName: null,
}

export const modals: Reducer<ModalsState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.OPEN_MODAL:
      return {
        ...state,
        visible: true,
        modalType: action.payload.name,
        data: action.payload.data,
        syntheticRouteName: action.payload.syntheticRouteName,
      }
    case ActionTypes.CLOSE_MODAL:
      return {
        ...state,
        visible: false,
        modalType: '',
        data: null,
        syntheticRouteName: null,
      }
    case ActionTypes.SET_MODAL_DATA:
      return {
        ...state,
        data: action.payload.data,
      }
    default:
      return state
  }
}

export default modals
